<template>
    <div class="cameraView">
      <div class="scroll">
        <div id="reader"></div>
        <div class="info-panel">
          <div class="title">
            <img @click="closeCamera()" :src="exitArrow" alt="qr-code-icon">
            <h3>{{ t('mobile.scan_title') }}</h3>
            
          </div>
          <p>{{ t('mobile.scan_description') }}</p>
        </div>
      </div>
    </div>
</template>
<script setup>
import { ref,onMounted,watch } from 'vue'
import exitArrow from '@/assets/exit-arrow.svg';
import {Html5QrcodeScanner,Html5Qrcode} from "html5-qrcode";
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import { onUnmounted } from 'vue';
import {readJSON} from '@/utils/fetch.js'; 
import { useI18n } from "vue-i18n";

let html5QrCode = null;
const { t } = useI18n();

function closeCamera() {
    useItineraryStore().showCamera = false;
}

onMounted(async () => {
    Html5Qrcode.getCameras().then(async (devices) => {
  if (devices && devices.length) {
    html5QrCode = new Html5Qrcode("reader");
    try {
      await html5QrCode.start(
        { facingMode: "environment" }, // Prefer rear camera, if available
        {
          fps: 10,    // Optional, frame per seconds for qr code scanning
          qrbox: { width: 250, height: 250 }  
        },
        (decodedText, decodedResult) => {
          let parameter = decodedText.split("?");

          if(parameter.length > 0) {
            readJSON(useItineraryStore().dataUrl + parameter[1] + '.json',function (result){
              if(result == undefined){
                console.log("result is undefined");
                useItineraryStore().IfNewData(false,parameter[1]);
                useItineraryStore().showCamera = false;
              }else {
                let resultObject = JSON.parse(result);
                useItineraryStore().IfNewData(resultObject,parameter[1] );
                useItineraryStore().showCamera = false;
              }
            });
          }
        },
        errorMessage => {
          console.log(`QR Code no longer detected: ${errorMessage}`);
        }
      );
    } catch (err) {
      console.error(`Unable to start scanning: ${err}`);
    }
  }
});
});

onUnmounted(() => {
    if(html5QrCode) {
        html5QrCode.stop().then(() => {
            console.log("QR Code stopped");
        }).catch((err) => {
            console.error("Error stopping QR Code: ",err);
        });
    }
});
</script>
<style scoped lang="scss">
#reader {
  z-index:9;
}
.cameraView {
  position: absolute;
  top: 70px;
  left: 0;
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  display: flex; 
  flex-direction: column; 

  .scroll {
    overflow-y: auto; 
    flex: 1;
    -webkit-overflow-scrolling: touch; 
  }
}
.info-panel, .title, p {
  width: 100%; 
}
    .info-panel {
      color:#000;
      padding:0 20px;
      p {
        height: 150px;
      }
    }
    
    .title {  
      display: flex;
      img {
        margin-right:15px;
      }
    }
</style>